<template>
  <UDropdown v-if="locale" :items="options" class="mt-2" :popper="{ placement: 'top' }">
    <UButton color="white" label="Select" trailing-icon="i-heroicons-chevron-down">
      <span v-if="flags[locale.code]" class="text-lg mr-1">{{ flags[locale.code] }}</span>
      <span>{{ locale?.name }}</span>
    </UButton>

    <template #item="{ item }">
      <span v-if="flags[item.code]" class="text-lg mr-1">{{ flags[item.code] }}</span>
      <span class="truncate">{{ item.label }}</span>
    </template>
  </UDropdown>
</template>

<script setup lang="ts">
const { $i18n } = useNuxtApp()

const flags = ref({
  en: '🇬🇧',
  es: '🇪🇸',
  et: '🇪🇪',
  nl: '🇳🇱',
  fr: '🇫🇷',
  it: '🇮🇹',
  sl: '🇸🇮',
  de: '🇩🇪',
  ja: '🇯🇵',
  fa: '🇮🇷',
  pt: '🇵🇹',
  hr: '🇭🇷',
  hu: '🇭🇺',
  'en-IE': '🇮🇪',
  'en-US': '🇺🇸',
  'en-AU': '🇦🇺',
  'fr-CA': '🇨🇦',
})

const options = computed(() => {
  const locales = $i18n.locales.value.map((locale) => {
    return {
      label: locale.name,
      code: locale.code,
      click: () => {
        $i18n.setLocale(locale.code)
      }
    }
  })

  return [
    locales
  ]
})

const locale = computed(() => {
  return $i18n.locales.value.find((locale) => {
    return locale.code === $i18n.locale.value
  })
})
</script>